import React from 'react'

import box_bg from '../../assets/box_bg.png'
import project_bg from '../../assets/ww.png'

const Privacy = () => {
	return (
		<>
			<section
				className='privacy project_jumbo jumbo_section'
				style={{ background: `url(${box_bg})`, backgroundPosition: 'bottom' }}
			>
				<div className='container'>
					<div className='d-flex privacy_jumbo_text'>
						<div>
							<h1>Privacy Policy</h1>
						</div>
					</div>
				</div>
			</section>

			<section
				className='privacy_div'
				style={{ background: `url(${project_bg})` }}
			>
				<div className='container'>
					<h4>
						THIS PRIVACY POLICY IS IN ADDITION TO AND IS INCORPORATED INTO THE
						END USER LICENSE AGREEMENT. IT REFERS TO SLEEPRATE’S END-USERS.
					</h4>
					<h5>General</h5>
					<p>
						All terms in capital letters not otherwise defined herein, shall
						have the meaning ascribed to them in the Application’s End User
						Terms of Use as they appear This Privacy Policy sets forth our
					</p>
					<p>
						policy and practices with respect to personal information that will
						be processed by us in relation to (i) your browsing through our
						download page/landing page, if applicable and (ii)your download and
						use of the Application and Services. Any information that does not
						constitute personal data, is out of the scope of this Privacy
						Policy. By clicking on the “I accept” (or similar consent) button or
						by using our Website, the System, the Services and/or the data,
						accessing, browsing or otherwise submitting information, to the
						Website, you acknowledge and consent to the collection, process and
						use of such information by Sleeprate as set forth below and in the
					</p>
					<p>
						End User License Agreement If You do not agree to any of these
						terms, You may not use, and therefore immediately must cease any use
						of, the System, the Services, Application and/or the Website. You
						acknowledge and understand, that Sleeprate’s Website, System and
						Services are neither a medical device, nor a medical program, and
						are not intended for the diagnosis and/or treatment of sleep
						disorders, and no input provided by the Website, System, Application
						and Services or shall be considered or related to as medical advice.
						“Non-Personal Data” as used in this Privacy Policy is therefore any
						information that does not relate to a person and/or cannot be used
						to identify a person. We may also use Non-Personal data. The
						limitations and requirements in this Privacy Policy on our
						gathering, use, disclosure, transfer and storage/retention of
						Personal Data, do not apply to Non-Personal Data
					</p>
				</div>
			</section>
		</>
	)
}

export default Privacy
